<template>
  <div class="content d-flex justify-content-center align-items-center">
    <form class="login-form">
      <div class="card mb-0">
        <div class="card-body">
          <div class="form-group text-center">
            <h4>Atenção!</h4>
            <h6>
              Não é possível fazer login no modulo com os parametros atuais,
              acesse o Portal e tente acessar pelo link.
            </h6>
            <a :href="`${portalUrl}`" class="btn btn-primary btn-block">
              Acessar o Portal
            </a>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import PATHS from '@/router/routesMap'

export default {
  name: 'Auth',

  components: {},

  data() {
    return {
      disableButton: false,
      messageError: '',
      invalidCredentials: false,
      portalUrl: process.env.VUE_APP_NPS_URL,
    }
  },

  methods: {
    async signIn() {
      this.disableButton = true
      try {
        const urlParams = this.$route.query

        if (
          urlParams.userId &&
          urlParams.unityId &&
          urlParams.unityName &&
          urlParams.name &&
          urlParams.email
        ) {
          const a = await this.$store.dispatch('auth', {
            userId: urlParams.userId,
            unityId: urlParams.unityId,
            unityName: urlParams.unityName,
            name: urlParams.name,
            email: urlParams.email,
            photo: `${process.env.VUE_APP_PHOTO_URL}${urlParams.photo}`,
          })
          this.disableButton = false
          this.$router.go(PATHS.HOME)
        } else {
          this.invalidCredentials = true
          this.disableButton = false
        }
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.signIn()
  },
}
</script>
